import { MutationTree } from "vuex";

import { State } from "./state";
import { FilterMutationTypes as MutationTypes } from "./mutation-types";
import {FilterCheckData, FilterData, FilterSlideData, FilterSlideIdentifier} from "@/types";

export type Mutations<S = State> = {
    [MutationTypes.SET_DATA](state: S, payload: FilterData): void;
    [MutationTypes.SET_SORT](state: S, payload: string): void;
    [MutationTypes.CHANGE_PARAMETER](state: S, payload: FilterCheckData): void;
    [MutationTypes.CHANGE_SLIDE_VALUE](state: S, payload: FilterSlideIdentifier): void;
    [MutationTypes.CLEAR_CHECKS](state: S, payload: FilterCheckData[] | []): void;
    [MutationTypes.CLEAR_SLIDES](state: S, payload: FilterSlideData[] | []): void;
};

export const mutations: MutationTree<State> & Mutations = {
    [MutationTypes.SET_DATA](state: State, data: FilterData) {
        state.filterTitle = data.filterTitle;
        state.cancelFilterLabel = data.cancelFilterLabel;

        state.sections = [];
        data.filters?.forEach((filterType) => {
            filterType.data.groups.length &&
                filterType.data.groups.forEach((filterGroup) => {
                    if (!Array.isArray(filterGroup.data) && filterGroup.type === "check") {
                        filterGroup.data = Object.values(filterGroup.data);
                    }
                    state.sections = [...state.sections, filterGroup];
                });
        });

        state.sort = data.sort ? {
            ...data.sort,
            available: data.sort.available.filter((sortBtn) => !sortBtn.value.startsWith("n")) } : null;

        state.resultsTotalCount = data.totalProductCount;
        state.resultsTotalLabel = data.totalProductLabel;
        state.url = data.url;

        state.showLessLabel = data.showLessLabel;
        state.showMoreLabel = data.showMoreLabel;
    },
    [MutationTypes.SET_SORT](state: State, sortType: string) {
        if (state.sort) {
            state.sort.selected = sortType;
        }
    },
    [MutationTypes.CHANGE_PARAMETER](state: State, control: FilterCheckData) {
        if (control && Object.hasOwnProperty.call(control, "checked")) {
            control.checked = !control.checked;
        }
    },
    [MutationTypes.CHANGE_SLIDE_VALUE](state: State, slideData: FilterSlideIdentifier) {
        const slide = slideData.control;
        if (slide?.nameMin === slideData.type && slideData.value !== undefined) {
            slide.minValue = slide.minParam = slideData.value;
        } else if (slide?.nameMax === slideData.type && slideData.value !== undefined) {
            slide.maxValue = slide.maxParam = slideData.value;
        }
    },
    [MutationTypes.CLEAR_CHECKS](state: State, selectedChecks: FilterCheckData[] | []) {
        selectedChecks.forEach((control) => {
            if (control && Object.hasOwnProperty.call(control, "checked")) {
                control.checked = false
            }
        });
    },
    [MutationTypes.CLEAR_SLIDES](state: State, changedSlides: FilterSlideData[] | []) {
        changedSlides.forEach((slide) => {
            slide.minValue = slide.minParam = slide.maxParam = 0;
            slide.maxValue = slide.max;
        });
    },
};